module.exports = __webpack_public_path__ + "static/img/frame_wac_indivisual.ad7dcc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificate/frame_wac_indivisual.png
// module id = Qix5
// module chunks = 1